import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import PublicPortfolioEducationHistory from '@/components/partials/public-portfolio/PublicPortfolioEducationHistory/PublicPortfolioEducationHistory.vue';
import PublicPortfolioEducationHistoryModal from '@/components/partials/public-portfolio/PublicPortfolioEducationHistory/PublicPortfolioEducationHistoryModal.vue';
import PublicPortfolioEducationHistorySectionModal from '@/components/partials/public-portfolio/PublicPortfolioEducationHistory/PublicPortfolioEducationHistorySectionModal.vue';
import { sortByDateField } from '@/components/utils/sorting_func';
import type { PublicPortfolioUser, PublicPortfolioConfiguration, EducationHistory } from '@/types/graphql';

type PublicPortfolioEducationHistorySectionProps = {
  user: PublicPortfolioUser;
  configuration?: PublicPortfolioConfiguration | null;
  editable?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioEducationHistorySection',
  props: {
    user: null,
    configuration: { default: null },
    editable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { user: PublicPortfolioUser, configuration: PublicPortfolioConfiguration | null, editable: boolean };



const FAKE_UNIVERSITY: EducationHistory = {
  degreeName: 'Level of degree',
  university: { id: '', name: 'Instituion name', custom: true, verified: false },
  manuallyEdited: true,
  startDate: '2014-02-01T00:00:00',
};
const fakeEducationHistories = [FAKE_UNIVERSITY, FAKE_UNIVERSITY];

const educationHistories = computed(() => {
  const educations = (props.user.educationHistories ?? []).sort(sortByDateField('startDate')).reduce(
    (acct, educationHistory) => {
      const key = educationHistory.endDate ? 'past' : 'current';
      return {
        ...acct,
        [key]: [...acct[key], educationHistory],
      };
    },
    { current: [], past: [] },
  );
  return [...educations.current, ...educations.past];
});
const isEmpty = computed(() => !educationHistories.value.length);
const rootStyles = computed(() => ({
  'public-portfolio-education-history-section': true,
  'public-portfolio-education-history-section--empty': isEmpty.value,
}));

return { __sfc: true,props, FAKE_UNIVERSITY, fakeEducationHistories, educationHistories, isEmpty, rootStyles, PublicPortfolioEducationHistory, PublicPortfolioEducationHistoryModal, PublicPortfolioEducationHistorySectionModal }
}

})